module.exports = __webpack_public_path__ + "img/BloodTypes.955b3465.svg";